import styled from 'styled-components';
import { TableRow } from '../TableRow/TableRow.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../../foundation/breakpoints/values.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { TableBodyCell } from '../TableCell/TableBodyCell/TableBodyCell.js';

var TableCollapseBodyCell = styled.td.withConfig({
  displayName: "TableCollapseBodyCell",
  componentId: "sc-4d6h77-0"
})(["padding:", " ", ";", "{", "}"], themeGet('spacing.sm'), themeGet('spacing.md'), breakpoints.sm, function (props) {
  return "padding: " + themeGet('spacing.xl') + " calc(" + themeGet('spacing.2xl') + " + " + pxToRem(props.$offset) + ");";
});
var StyledTableBodyCell = styled(TableBodyCell).withConfig({
  displayName: "StyledTableBodyCell",
  componentId: "sc-4d6h77-1"
})(["", "{display:none;}"], function (props) {
  return props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint];
});
var TableCollapseRow = styled(TableRow).withConfig({
  displayName: "TableCollapseRow",
  componentId: "sc-4d6h77-2"
})(["", "{display:none;}"], function (props) {
  return props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint];
});

export { StyledTableBodyCell, TableCollapseBodyCell, TableCollapseRow };
